// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PaymentTransactionsController = function ($scope, $routeParams, PaymentTransactions, PSPTransactionData) {
    $scope.filter = {
        search: $routeParams.entityId || $routeParams.customerId || $routeParams.contractId,
        before: "",
        after: "" };
    $scope.hideShowPreauth = function () {
        $scope.loadPayments();
    };
    $scope.loadPayments = function () {
        $scope.payments = $scope.paginator(function(options, callback) {
                return PaymentTransactions.query(options, function() { callback(); });
            },
            {
                searchFilter: $scope.filter.search,
                providerFilter: $scope.filter.provider,
                paymentMethodFilter: $scope.filter.paymentMethod,
                triggerFilter: $scope.filter.trigger,
                statusFilter: $scope.filter.status,
                preauthFilter: $scope.filter.preauth,
                before: $scope.filter.before,
                after: $scope.filter.after
            },
            100);
    }

    $scope.getPspData = function (id) {
        PSPTransactionData.get({ transactionId: id }, function (data) {
            alert(data.Response);
        });
    }

    $scope.onResetFilterClick = function() {
        $scope.filter.search = null; 
        $scope.filter.contractId = null;
        $scope.loadPayments();
    }

    $scope.loadPayments();

    $scope.BuildPgTransactionId = function (billwerkTransactionId) {
        const datePartOfId = new Date(parseInt(billwerkTransactionId.substring(0, 8), 16) * 1000).toISOString()
            .slice(0, 10)
            .replace(/-/g, '');
        return `${datePartOfId}-${billwerkTransactionId}`;
    }
};
PaymentTransactionsController.$inject = ['$scope', '$routeParams', 'PaymentTransactions', 'PSPTransactionData'];
